import React, { Fragment, useState } from 'react'
import estilos from '../Zonas/ZonasListComponent.module.css'
import Tooltip from '@mui/material/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faPen, faCalendar, faEye, faArrowUp, faTrash
} from '@fortawesome/free-solid-svg-icons'

import { eliminarAsociadoLocalidad } from '../../../redux/DucksUnidadInspeccion/AsociadosEnLaLocalidadDuck';
import { obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/AtencionAClienteDucks';

import { useDispatch, useSelector } from 'react-redux'
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import SolicitudesPorAsociadoComponent from './SolicitudesPorAsociadoComponent';

function AsociadoItemComponent(props) {

    const asociado = props.asociado;
    const solicitudes = useSelector(store => store.AtencionSolicitud.data)
    const dispatch = useDispatch()

    const [modalBorrarZona, setModalBorrarZona] = React.useState(false);
    const [modalSolicitudes, setModalSolicitudes] = React.useState(false);

    const [solicitudesAsociado, setSolicitudesAsociado] = React.useState([]);

    const handleAbrirModalBorrarZona = () => {
        setModalBorrarZona(true);
    }

    const handleCerrarModalBorrarZona = () => {
        setModalBorrarZona(false);
    }

    const handleAbrirModalSolicitudes = () => {
        setModalSolicitudes(true);
    }

    const handleCerrarModalSolicitudes = () => {
        setModalSolicitudes(false);
    }

    React.useEffect(() => {
        dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
    }, [])

    React.useEffect(() => {
        setSolicitudesAsociado(solicitudes.fc_01_solicitudderegistro.filter(solicitud => solicitud.numerosocio == asociado.anexocliente.cliente.numerosocio))
    }, [solicitudes])

    React.useEffect(() => {
        solicitudesAsociado
    }, [solicitudesAsociado])

    const styleModalConfirmacion = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 500, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
        p: 4, fontSize: '20px', textAlign: 'center'
    };


    const eliminarAsociado = () => {
        dispatch(eliminarAsociadoLocalidad(asociado.idasociadolocalidad))
        props.actualizarZonas()
        setModalBorrarZona(false);
        //props.handleCloseModalAsociados()
    }

    const HTMLmodalBorrarAsociado = () => {
        return (
            <Modal
                open={modalBorrarZona}
                onClose={handleCerrarModalBorrarZona}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModalConfirmacion} >
                    <h3>Borrar Asociado</h3>
                    Estás seguro de querer borrar este asociado de esta sublocalidad? <br></br>                   <br /><br />
                    <button onClick={() => eliminarAsociado()} className='btn btn-danger'>Si, estoy seguro</button>
                </Box>

            </Modal>
        )
    }

    const style = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 1200, bgcolor: 'background.paper',
        border: '2px solid #000', boxShadow: 24, p: 4, overflow: 'scroll', height: '90%',
    };

    const actualizarSolicitudes = () => {
        dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
    }

    const HTMLmodalverSolicitudes = () => {
        return (
            <Modal
                open={modalSolicitudes}
                onClose={handleCerrarModalSolicitudes}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={style} >
                    <SolicitudesPorAsociadoComponent solicitudes={solicitudesAsociado} asociado={asociado} actualizarSolicitudes={actualizarSolicitudes} handleCerrarModalSolicitudes={handleCerrarModalSolicitudes}></SolicitudesPorAsociadoComponent>
                </Box>

            </Modal>
        )
    }

    return (
        <Fragment><br />
            {
                <div className={
                    asociado.estado === 1 ?
                        `alert alert-success ${estilos.alertItem}` :
                        `alert alert-secondary ${estilos.alertItem}`} role="alert" >
                    <div className='row'>
                        <div className='col-md-10 mt-2' style={{ textAlign: "left", paddingLeft: "2%" }}>
                            <h5>{asociado.anexocliente.tipoanexo.descripcion.toUpperCase()}</h5>
                        <h6><strong>{asociado.anexocliente.informaciongeneralinstalacioncliente.alias}</strong></h6>
                            <h6><strong>{asociado.anexocliente.cliente.numerosocio} | {asociado.anexocliente.cliente.nombrerazonsocial}</strong></h6>
                            <h6>Domicilio: <strong>{asociado.anexocliente.informaciongeneralinstalacioncliente.estado}, {asociado.anexocliente.informaciongeneralinstalacioncliente.municipio}, {asociado.anexocliente.informaciongeneralinstalacioncliente.colonia}, {asociado.anexocliente.informaciongeneralinstalacioncliente.calle}, {asociado.anexocliente.informaciongeneralinstalacioncliente.numeroexterior}, {asociado.anexocliente.informaciongeneralinstalacioncliente.numerointerior}</strong></h6>
                        </div>
                        <div className='col-md-2' style={{ fontSize: '30px', textAlign: 'center' }}>
                            <Tooltip title="Eliminar de esta zona">
                                <button className={`${estilos.botonItemZona} ${estilos.zoom2} text-wrap text-center`} onClick={handleAbrirModalBorrarZona}><FontAwesomeIcon icon={faTrash} /></button>
                            </Tooltip>
                            {/* <Tooltip title="Reasignar Asociado">
                                <button className={`${estilos.botonItemZona} ${estilos.zoom2} text-wrap text-center`} onClick={() => props.handleOpenModalDesvincularAsociado(asociado)}><FontAwesomeIcon icon={faPen} /></button>
                            </Tooltip>
                             */}
                            {/* <Tooltip title="Ver Solicitudes">
                                <button className={`${estilos.botonItemZona} ${estilos.zoom2} text-wrap text-center`} onClick={handleAbrirModalSolicitudes}><FontAwesomeIcon icon={faCalendar} /></button>
                            </Tooltip> */}
                            <Tooltip title="Ver Información">
                                <button className={`${estilos.botonItemZona} ${estilos.zoom2} text-wrap text-center`} onClick={() => props.handleOpenModalVerInfoDelAsociado(asociado)}><FontAwesomeIcon icon={faEye} /></button>
                            </Tooltip>
                        </div>
                    </div>
                </div>
            }
            {HTMLmodalBorrarAsociado()}
            {HTMLmodalverSolicitudes()}
        </Fragment>
    )
}

export default AsociadoItemComponent